import React from 'react'
import './experience.css'
import SkillsSection from './SkillsSection'

const Experience = () => {
    return (
        <section id='experience'>
            <h5> What Skills I Have</h5>
            <h2>My Experience</h2>

            <div className="container">
                <SkillsSection />
            </div>
        </section>
    )
}

export default Experience
